import { createSlice } from "@reduxjs/toolkit";
import { GetAllBranches } from "./HeaderApi";

const initialState = {
  loginedBranch: [],
  buSearch: "",
  selectedBusinessUnit: {},
};

const HeaderSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    handleSelectedBU: (state, { payload }) => {
      if (payload.check === "search") {
        state.buSearch = payload.value;
        localStorage.setItem("selectedBranch", JSON.stringify(payload.value));
      }
      if (payload.check === "select") {
        state.selectedBusinessUnit = payload.value;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetAllBranches.fulfilled, (state, payload) => {
      state.loginedBranch = payload?.payload?.data;
      localStorage.setItem(
        "branch_settings",
        JSON.stringify(payload?.payload?.data?.branch_sel_data)
      );
    });
  },
});

export const { handleSelectedBU } = HeaderSlice.actions;
export default HeaderSlice.reducer;
